__turbopack_context__.v({
  "actionGroup": "AgYl4G_actionGroup",
  "paymentWrapper": "AgYl4G_paymentWrapper",
  "shipping": "AgYl4G_shipping",
  "total": "AgYl4G_total",
  "totalPrice": "AgYl4G_totalPrice",
  "totalPriceWrapper": "AgYl4G_totalPriceWrapper",
});
